import React from "react";

import { SETTINGS_TABS } from "../../contents/constants";
import Account from "../account";
import AutoApplyNew from "../autoApplyNew/index";
import EmailNotifications from "../email-notifications";
import Profile from "../profile";
import { AutoApplyData } from "../utils/fetchAutoApply";

type ActiveTabComponentProps = {
  isMobile: boolean;
  activeLabel: string;
  activeTab: string;
  autoApplyData: AutoApplyData | null;
};

const ActiveTabComponent = ({
  isMobile,
  activeLabel,
  activeTab,
  autoApplyData,
}: ActiveTabComponentProps) => {
  const renderComponentBasedOnTab = (tabName: string) => {
    switch (tabName) {
      case SETTINGS_TABS.PROFILE.name:
        return <Profile />;
      case SETTINGS_TABS.EMAIL_NOTIFICATION.name:
        return <EmailNotifications />;
      case SETTINGS_TABS.ACCOUNT.name:
        return <Account />;
      case SETTINGS_TABS.AUTO_APPLY.name:
        return <AutoApplyNew data={autoApplyData} />;
      default:
        return <div>Tab not found</div>;
    }
  };
  return (
    <>
      {activeLabel && isMobile && (
        <div
          className={`setptings-content-container m-3 ${isMobile ? "mt-0" : ""}md:mx-10 md:my-3 md:w-[55%]`}
        >
          {renderComponentBasedOnTab(activeTab)}
        </div>
      )}

      {!isMobile && (
        <div
          className={`setptings-content-container m-3 ${isMobile ? "mt-0" : ""}md:mx-10 md:my-3 md:w-[55%]`}
        >
          {renderComponentBasedOnTab(activeTab)}
        </div>
      )}
    </>
  );
};

export default ActiveTabComponent;
